import { gql } from "@apollo/client";
import { useChainId } from "lib/chains";
import { getPalmSubgraph } from "lib/subgraph";
import useSWR from "swr";

export function useUsers() {
  const { chainId } = useChainId();

  const client = getPalmSubgraph(chainId, "stats");

  async function fetcher() {
    const query = gql`
      {
        userStat(id: "total") {
          id
          uniqueCountCumulative
          actionCount
        }
      }
    `;

    const res = await client.query<{
      userStat: {
        id: string;
        uniqueCountCumulative: string;
        actionCount: string;
      };
    }>({
      query,
      fetchPolicy: "network-only",
    });

    if (res.errors) {
      return {
        error: res.errors,
      };
    }

    const userData = res.data.userStat;

    return {
      users: {
        uniqueCountCumulative: userData.uniqueCountCumulative,
        actionCount: userData.actionCount,
      },
    };
  }

  const swr = useSWR(["Exchange:fees-and-users"], fetcher, {
    refreshInterval: 15000,
  });

  return swr;
}
